module.exports = __webpack_public_path__ + "img/signup-guide-05-04.8906e391.png";